import { render, staticRenderFns } from "./CommunicationsSent.vue?vue&type=template&id=1e83fad8"
import script from "./CommunicationsSent.vue?vue&type=script&lang=js"
export * from "./CommunicationsSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports